import { Textarea } from "../../../components/ui/textarea";
import { Label } from "../../../components/ui/label";
import { publicFileUrl } from "../../../lib/plans";
import { Group, Field, SaveBar, UploadField, useDraft, useSectionSave } from "./shared";

export const BrandingSection = () => {
  const { settings, save, busy } = useSectionSave();
  const [b, setB] = useDraft(settings.branding);
  const [c, setC] = useDraft(settings.contact);
  const sb = (k) => (v) => setB({ ...b, [k]: v });
  const sc = (k) => (v) => setC({ ...c, [k]: v });
  return (
    <div className="space-y-6">
      <Group title="Site identity" desc="Shown in the navigation bar, footer and on membership ID cards.">
        <Field label="Site name" value={b.site_name} onChange={sb("site_name")} testId="branding-site-name-input" />
        <Field label="Tagline (leave empty to use the translated default)" value={b.tagline} onChange={sb("tagline")} testId="branding-tagline-input" />
        <UploadField label="Logo" kind="logo" accept="image/png,image/jpeg,image/webp" path={b.logo_path} onChange={sb("logo_path")} testId="branding-logo"
          hint="PNG, JPG or WEBP up to 8MB. A square image looks best."
          preview={<img src={publicFileUrl(b.logo_path)} alt="" className="h-12 w-12 rounded-lg border object-contain" data-testid="branding-logo-preview" />} />
      </Group>
      <Group title="Browser title & description" desc="Updates the browser tab and page description. Link previews on Telegram/WhatsApp keep the published title until the next re-publish.">
        <Field label="Browser title" value={b.browser_title} onChange={sb("browser_title")} testId="branding-browser-title-input" />
        <div className="space-y-1.5"><Label>Meta description</Label><Textarea value={b.meta_description || ""} onChange={(e) => sb("meta_description")(e.target.value)} data-testid="branding-meta-input" /></div>
      </Group>
      <Group title="Contact information" desc="Used by the Contact section, footer and the Telegram / WhatsApp buttons.">
        <div className="grid gap-4 md:grid-cols-2">
          <Field label="Telegram link" value={c.telegram} onChange={sc("telegram")} testId="contact-telegram-input" />
          <Field label="WhatsApp number (digits with country code)" value={c.whatsapp} onChange={sc("whatsapp")} testId="contact-whatsapp-input" />
          <Field label="Email (optional)" value={c.email} onChange={sc("email")} testId="contact-email-input" />
          <Field label="Phone (optional)" value={c.phone} onChange={sc("phone")} testId="contact-phone-input" />
        </div>
        <Field label="Official address" value={c.address} onChange={sc("address")} testId="contact-address-input" />
      </Group>
      <SaveBar onClick={() => save({ branding: b, contact: c })} busy={busy} testId="branding-save-btn" />
    </div>
  );
};
